import React, { useEffect, useState, useMemo } from 'react';
import './AffiliateDashboard.scss';
import { Breadcrumbs, Typography } from '@material-ui/core';
import Popover from '@material-ui/core/Popover';
import { http, localstorage, useNavigationService } from '../../fx-core';

const pick = (obj: any, ...keys: string[]) => {
  for (const k of keys) {
    if (obj[k] !== undefined && obj[k] !== null) return obj[k];
    const found = Object.keys(obj).find((ok) => ok.toLowerCase() === k.toLowerCase());
    if (found && obj[found] !== null) return obj[found];
  }
  return undefined;
};

const AffiliateDashboard = (props: any) => {
  const { navigate } = useNavigationService();
  const currentUserId = parseInt(localstorage.getItem('userId') || '0');

  const [viewMode, setViewMode] = useState<'reselling' | 'myproducts'>('reselling');
  const [products, setProducts] = useState<any[]>([]);
  const [merchantSideProducts, setMerchantSideProducts] = useState<any[]>([]); // who resells my products
  const [resellerEarnings, setResellerEarnings] = useState<any[]>([]); // what each reseller actually earned from my products
  const [loading, setLoading] = useState(true);
  const [lastUpdated, setLastUpdated] = useState(new Date());

  // Tracking popover + live stats
  const [trackingAnchorEl, setTrackingAnchorEl] = useState<null | HTMLElement>(null);
  const [myTrackable, setMyTrackable] = useState<any[]>([]);
  const [affiliateNotifications, setAffiliateNotifications] = useState<any[]>([]);
  const [salesCount, setSalesCount] = useState(0);
  const [commission, setCommission] = useState(0);
  const [mySales, setMySales] = useState<any[]>([]);
  const [dateFilter, setDateFilter] = useState<'all' | 'today' | 'week' | 'month' | 'year' | 'custom'>('all');
  const [customFrom, setCustomFrom] = useState('');
  const [customTo, setCustomTo] = useState('');

  
  const quickFilters = [
    { key: 'all' as const, label: 'All Time', icon: 'fa-infinity' },
    { key: 'today' as const, label: 'Today', icon: 'fa-calendar-day' },
    { key: 'week' as const, label: 'This Week', icon: 'fa-calendar-week' },
    { key: 'month' as const, label: 'This Month', icon: 'fa-calendar-alt' },
    { key: 'year' as const, label: 'This Year', icon: 'fa-calendar' },
  ];

  const [myStallSlug, setMyStallSlug] = useState<string | null>(null);
const [productSearch, setProductSearch] = useState('');
const [showAllDetails, setShowAllDetails] = useState(false);
const [expandedIds, setExpandedIds] = useState<Set<any>>(new Set());

const toggleExpand = (id: any) => {
  setExpandedIds((prev) => {
    const next = new Set(prev);
    if (next.has(id)) next.delete(id); else next.add(id);
    return next;
  });
};

  useEffect(() => {
    http.post({ url: 'stall/owner', data: { CurrentDate: new Date().toISOString() } }).then((res: any) => {
      const stalls = Array.isArray(res.data) ? res.data : [];
      if (stalls.length > 0) {
        const stallObj = pick(stalls[0], 'Stall', 'stall') || stalls[0];
        setMyStallSlug(pick(stallObj, 'slug'));
      }
    }).catch(() => setMyStallSlug(null));
  }, []);

  const fetchAll = (isBackgroundRefresh = false) => {
    if (!isBackgroundRefresh) {
      setLoading(true);
    }
    http.get({ url: 'affiliate-product/reseller/' + currentUserId }).then((res: any) => {
        setProducts(Array.isArray(res.data) ? res.data : []);
        setLastUpdated(new Date());
        setLoading(false);
      }).catch(() => {
        // Fallback: derive from accepted requests endpoint if it exists
        http.get({ url: 'affiliate-product/my-requests' }).then((res2: any) => {
          setProducts(Array.isArray(res2.data) ? res2.data : []);
          setLastUpdated(new Date());
          setLoading(false);
        }).catch(() => { setProducts([]); setLoading(false); });
      });

      // Merchant-side data (who's reselling my products)
      http.get({ url: 'affiliate-product/merchant/' + currentUserId }).then((res: any) => {
        setMerchantSideProducts(Array.isArray(res.data) ? res.data : []);
      }).catch(() => setMerchantSideProducts([]));

      // What each of my resellers actually earned from my products
      http.get({ url: 'affiliate-product/reseller-earnings' }).then((res: any) => {
        setResellerEarnings(Array.isArray(res.data) ? res.data : []);
      }).catch(() => setResellerEarnings([]));

            http.get({ url: 'affiliate-product/my-sales' }).then((res: any) => {
        const list = Array.isArray(res.data) ? res.data : [];
        setMySales(list);
      }).catch(() => { setMySales([]); });

           http.get({ url: `notification/user/${currentUserId}` }).then((res: any) => {
        const all = Array.isArray(res.data) ? res.data : [];
        const unread = all.filter((n: any) =>
          AFFILIATE_NOTIFICATION_CATEGORIES.includes(n.notificationCategory) && !n.isRead
        );
        setHasUnreadNotifications(unread.length > 0);
        setUnreadMerchantCount(unread.filter((n: any) => n.notificationCategory === 'AffiliateRequest').length);
        setUnreadSupplierCount(unread.filter((n: any) => n.notificationCategory !== 'AffiliateRequest').length);
      }).catch(() => {});
    };

  useEffect(() => {
    fetchAll(); // first load — show spinner

    const intervalId = setInterval(() => {
      fetchAll(true); // background refresh — no spinner, no flash
    }, 20000);

    return () => clearInterval(intervalId);
  }, []);

  const navToDashboard = () => {
    navigate({ targetRoute: '', targetTitle: 'Dashboard', targetData: {}, sourceState: {}, eventSource: '' });
  };

   const AFFILIATE_NOTIFICATION_CATEGORIES = ['AffiliateRequest', 'AffiliateAccepted', 'AffiliateRejected', 'AffiliateAddedToStall'];

    const handleTrackingIconClick = (event: React.MouseEvent<HTMLElement>) => {
    setTrackingAnchorEl(event.currentTarget);
    http.get({ url: 'affiliate-product/my-tracking' }).then((res: any) => {
      setMyTrackable(Array.isArray(res.data) ? res.data : []);
    }).catch(() => setMyTrackable([]));
  };

        const [bellAnchorEl, setBellAnchorEl] = useState<null | HTMLElement>(null);
  const [hasUnreadNotifications, setHasUnreadNotifications] = useState(false);
  const [unreadMerchantCount, setUnreadMerchantCount] = useState(0);
  const [unreadSupplierCount, setUnreadSupplierCount] = useState(0);
  const [sideBellAnchorEl, setSideBellAnchorEl] = useState<null | HTMLElement>(null);
  const [sideBellSide, setSideBellSide] = useState<'merchant' | 'supplier' | null>(null);

    const handleBellIconClick = (event: React.MouseEvent<HTMLElement>) => {
    setBellAnchorEl(event.currentTarget);
    setHasUnreadNotifications(false);
    http.get({ url: `notification/user/${currentUserId}` }).then((res: any) => {
      const all = Array.isArray(res.data) ? res.data : [];
      const affiliateOnly = all.filter((n: any) => AFFILIATE_NOTIFICATION_CATEGORIES.includes(n.notificationCategory));
      setAffiliateNotifications(affiliateOnly);
    }).catch(() => setAffiliateNotifications([]));
  };

      const handleSideBellClick = (event: React.MouseEvent<HTMLElement>, side: 'merchant' | 'supplier') => {
    event.stopPropagation();
    setSideBellAnchorEl(event.currentTarget);
    setSideBellSide(side);
    if (side === 'merchant') setUnreadMerchantCount(0);
    else setUnreadSupplierCount(0);
    http.get({ url: `notification/user/${currentUserId}` }).then((res: any) => {
      const all = Array.isArray(res.data) ? res.data : [];
      const affiliateOnly = all.filter((n: any) => AFFILIATE_NOTIFICATION_CATEGORIES.includes(n.notificationCategory));
      setAffiliateNotifications(affiliateOnly);
    }).catch(() => setAffiliateNotifications([]));
  };

   const goToNotificationTarget = (notif: any) => {
    setBellAnchorEl(null);
    setSideBellAnchorEl(null);
    if (notif.notificationCategory === 'AffiliateRequest') {
      navigate({
        targetRoute: '/provider/pendingaffiliaterequests',
        targetTitle: 'Pending Affiliate Requests',
        targetData: {}, sourceState: {}, eventSource: ''
      });
        } else if (
      notif.notificationCategory === 'AffiliateAccepted' ||
      notif.notificationCategory === 'AffiliateRejected' ||
      notif.notificationCategory === 'AffiliateAddedToStall'
    ) {
      const affiliateProductId = JSON.parse(notif.notificationData || '{}').affiliateProductId;
      if (affiliateProductId) {
        navigate({
          targetRoute: '/provider/affiliaterequestoutcome/' + affiliateProductId,
          targetTitle: 'Request Outcome',
          targetData: {}, sourceState: {}, eventSource: ''
        });
      }
    }
  };

  const goTracking = (id: any) => {
    setTrackingAnchorEl(null);
    navigate({
      targetRoute: '/provider/affiliatetracking/' + id,
      targetTitle: 'Tracking',
      targetData: {}, sourceState: {}, eventSource: ''
    });
  };

  const acceptedProducts = products.filter(
    (p: any) => (pick(p, 'requestStatus') ?? '').toLowerCase() === 'accepted'
  );

  const filteredSales = useMemo(() => {
    if (dateFilter === 'all') return mySales;
    if (dateFilter === 'custom') {
      if (!customFrom && !customTo) return mySales;
      const from = customFrom ? new Date(customFrom) : new Date(0);
      const to = customTo ? new Date(customTo + 'T23:59:59') : new Date();
      return mySales.filter((x: any) => {
        const d = new Date(x.CreatedDate || x.createdDate);
        return d >= from && d <= to;
      });
    }
    const now = new Date();
    let cutoff: Date;
    if (dateFilter === 'today') {
      cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    } else if (dateFilter === 'week') {
      cutoff = new Date(now);
      cutoff.setDate(now.getDate() - 7);
    } else if (dateFilter === 'month') {
      cutoff = new Date(now.getFullYear(), now.getMonth(), 1);
    } else {
      cutoff = new Date(now.getFullYear(), 0, 1);
    }
    return mySales.filter((x: any) => {
      const d = new Date(x.CreatedDate || x.createdDate);
      return d >= cutoff;
    });
  }, [mySales, dateFilter, customFrom, customTo]);

  // Reseller earnings also respect the date filter, same cutoff logic
  const filteredResellerEarnings = useMemo(() => {
    if (dateFilter === 'all') return resellerEarnings;
    if (dateFilter === 'custom') {
      if (!customFrom && !customTo) return resellerEarnings;
      const from = customFrom ? new Date(customFrom) : new Date(0);
      const to = customTo ? new Date(customTo + 'T23:59:59') : new Date();
      return resellerEarnings.filter((x: any) => {
        const d = new Date(x.CreatedDate || x.createdDate);
        return d >= from && d <= to;
      });
    }
    const now = new Date();
    let cutoff: Date;
    if (dateFilter === 'today') {
      cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    } else if (dateFilter === 'week') {
      cutoff = new Date(now);
      cutoff.setDate(now.getDate() - 7);
    } else if (dateFilter === 'month') {
      cutoff = new Date(now.getFullYear(), now.getMonth(), 1);
    } else {
      cutoff = new Date(now.getFullYear(), 0, 1);
    }
    return resellerEarnings.filter((x: any) => {
      const d = new Date(x.CreatedDate || x.createdDate);
      return d >= cutoff;
    });
  }, [resellerEarnings, dateFilter, customFrom, customTo]);

  useEffect(() => {
    setSalesCount(filteredSales.length);
    setCommission(filteredSales.reduce((s: number, x: any) => s + Number(x.Amount || x.amount || 0), 0));
  }, [filteredSales]);

   const getProductKey = (p: any) => pick(p, 'id', 'affiliateProductId', 'AffiliateProductId');
  const getSaleProductKey = (s: any) => pick(s, 'AffiliateProductId', 'affiliateProductId', 'ProductId', 'id');

    const getProductEarned = (productKey: any) => {
    return filteredSales
      .filter((x: any) => getSaleProductKey(x) === productKey)
      .reduce((s: number, x: any) => s + Number(x.Amount || x.amount || 0), 0);
  };

  // Merchant's kept amount for this product, from the counterpart data now included in my-sales
  const getProductCounterpartAmount = (productKey: any) => {
    return filteredSales
      .filter((x: any) => getSaleProductKey(x) === productKey)
      .reduce((s: number, x: any) => s + Number(pick(x, 'counterpartAmount') || 0), 0);
  };

  // Merchant's own kept amount for a given order (role === 'Merchant' row in my-sales)
  const getOrderMerchantAmount = (orderId: any) => {
    const row = mySales.find((s: any) => pick(s, 'orderId') === orderId && (pick(s, 'role') || '').toLowerCase() === 'merchant');
    return row ? Number(pick(row, 'amount') || 0) : 0;
  };

  // Sum of merchant's kept amount across all sales of one product (via reseller-earnings orderIds)
  const getProductMerchantEarning = (productId: any) => {
    return filteredResellerEarnings
      .filter((t: any) => pick(t, 'affiliateProductId') === productId)
      .reduce((sum: number, t: any) => sum + getOrderMerchantAmount(pick(t, 'orderId')), 0);
  };

  // Left list — merchants I resell from
  const merchants = useMemo(() => {
    const map: any = {};
    acceptedProducts.forEach((p: any) => {
      const id = pick(p, 'merchantId');
      if (id !== undefined && id !== null && !map[id]) {
        map[id] = { id, name: pick(p, 'merchantStallName') || ('Merchant #' + id) };
      }
    });
    return Object.values(map);
  }, [products]);

  // Left list — resellers of my products (built from merchantSideProducts)
  const myResellers = useMemo(() => {
    const map: any = {};
    merchantSideProducts
      .filter((p: any) => (pick(p, 'requestStatus') ?? '').toLowerCase() === 'accepted')
      .forEach((p: any) => {
        const id = pick(p, 'resellerId');
        if (id !== undefined && id !== null && !map[id]) {
          map[id] = { id, name: pick(p, 'resellerName') || ('Reseller #' + id) };
        }
      });
    return Object.values(map);
  }, [merchantSideProducts]);

  const renderSupplierBlock = (merchant: any) => {
    const merchantProducts = acceptedProducts.filter((p: any) => pick(p, 'merchantId') === merchant.id);
    const merchantSales = filteredSales.filter((s: any) =>
      merchantProducts.some((p: any) => getProductKey(p) === getSaleProductKey(s))
    );
    const commissionEarned = merchantSales.reduce((sum: number, s: any) => sum + Number(s.Amount || s.amount || 0), 0);

        const isOpen = expandedIds.has(merchant.id);

    return (
      <div className="merchant-detail-page fade-slide-in" key={merchant.id} style={{ marginBottom: 20, paddingBottom: 20, borderBottom: '1px solid #eee' }}>
        <div className="merchant-info-card pointer" onClick={() => toggleExpand(merchant.id)}>
          <div className="merchant-avatar">{merchant.name.charAt(0).toUpperCase()}</div>
          <div className="merchant-info-main">
            <div className="merchant-info-name">
              {merchant.name} <span className="status-pill active">Active</span>
            </div>
            <div className="merchant-info-sub">Supplier — products you're affiliating from them</div>
          </div>
          <div className="merchant-info-stats">
            <div className="mini-stat">
              <div className="mini-stat-label">Products I Promote</div>
              <div className="mini-stat-value">{merchantProducts.length}</div>
            </div>
            <div className="mini-stat">
              <div className="mini-stat-label">Sold Through My Link</div>
              <div className="mini-stat-value">{merchantSales.length}</div>
            </div>
            <div className="mini-stat">
              <div className="mini-stat-label">Commission I Earned</div>
              <div className="mini-stat-value">₹{commissionEarned.toFixed(2)}</div>
            </div>
          </div>
          <i className={`fas fa-chevron-${isOpen ? 'up' : 'down'} banner-arrow`} style={{ position: 'static', marginLeft: 8 }}></i>
        </div>

        {isOpen && (
          <div className="merchant-table-wrap">
            <table className="merchant-table">
                            <thead>
                <tr>
                  <th>#</th>
                  <th>Product Name</th>
                  <th>Commission Rate</th>
                  <th>Sold</th>
                  <th>Sale Amount</th>
                  <th>Merchant Earning</th>
                  <th>Your Commission</th>
                  <th>Action</th>
                </tr>
              </thead>
                            <tbody>
                {(() => {
                  const soldRows = merchantProducts
                    .map((p: any) => {
                      const productId = getProductKey(p);
                      const earned = getProductEarned(productId);
                      const merchantAmount = getProductCounterpartAmount(productId);
                      const soldCount = filteredSales.filter((s: any) => getSaleProductKey(s) === productId).length;
                      return { p, productId, earned, merchantAmount, soldCount };
                    })
                    .filter((row: any) => row.soldCount > 0);

                  if (soldRows.length === 0) {
                    return <tr><td colSpan={8} className="text-center text-muted py-4">No sold products yet.</td></tr>;
                  }

                  return soldRows.map((row: any, i: number) => {
                    const { p, productId, earned, merchantAmount, soldCount } = row;
                    const saleAmount = earned + merchantAmount;
                    return (
                      <tr key={productId ?? i}>
                        <td>{i + 1}</td>
                        <td><b>{pick(p, 'itemName')}</b></td>
                        <td>{pick(p, 'marginNumber')}%</td>
                        <td>{soldCount}</td>
                        <td>₹{saleAmount.toFixed(2)}</td>
                        <td>₹{merchantAmount.toFixed(2)}</td>
                        <td>₹{earned.toFixed(2)}</td>
                        <td>
                          <span className="pointer table-action" onClick={(e) => { e.stopPropagation(); goTracking(productId); }}>
                            <i className="fas fa-route"></i> Track
                          </span>
                        </td>
                      </tr>
                    );
                  });
                })()}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  };

  const renderMerchantBlock = (reseller: any) => {
    const resellerProducts = merchantSideProducts.filter((p: any) =>
      pick(p, 'resellerId') === reseller.id && (pick(p, 'requestStatus') ?? '').toLowerCase() === 'accepted'
    );
    const resellerTxns = filteredResellerEarnings.filter((t: any) => pick(t, 'userId') === reseller.id);
    const commissionPaid = resellerTxns.reduce((sum: number, t: any) => sum + Number(t.Amount || t.amount || 0), 0);
    const isOpen = expandedIds.has(reseller.id);

    return (
      <div className="merchant-detail-page fade-slide-in" key={reseller.id} style={{ marginBottom: 20, paddingBottom: 20, borderBottom: '1px solid #eee' }}>
        <div className="merchant-info-card pointer" onClick={() => toggleExpand(reseller.id)}>
          <div className="merchant-avatar">{reseller.name.charAt(0).toUpperCase()}</div>
          <div className="merchant-info-main">
            <div className="merchant-info-name">
              {reseller.name} <span className="status-pill active">Active</span>
            </div>
            <div className="merchant-info-sub">Merchant — reselling your products</div>
          </div>
          <div className="merchant-info-stats">
            <div className="mini-stat">
              <div className="mini-stat-label">Products They Promote</div>
              <div className="mini-stat-value">{resellerProducts.length}</div>
            </div>
            <div className="mini-stat">
              <div className="mini-stat-label">Sold By Them</div>
              <div className="mini-stat-value">{resellerTxns.length}</div>
            </div>
            <div className="mini-stat">
              <div className="mini-stat-label">Commission I Paid Them</div>
              <div className="mini-stat-value">₹{commissionPaid.toFixed(2)}</div>
            </div>
          </div>
          <i className={`fas fa-chevron-${isOpen ? 'up' : 'down'} banner-arrow`} style={{ position: 'static', marginLeft: 8 }}></i>
        </div>

                {isOpen && (
          <div className="merchant-table-wrap">
            <table className="merchant-table">
                           <thead>
                                <tr>
                  <th>#</th>
                  <th>Product Name</th>
                  <th>Commission Rate</th>
                  <th>Sold</th>
                  <th>Sale Amount</th>
                  <th>Merchant Earning</th>
                  <th>Affiliate Commission</th>
                  <th>Action</th>
                </tr>
                           </thead>
                           <tbody>
                {(() => {
                  const soldRows = resellerProducts
                    .map((p: any) => {
                      const productId = getProductKey(p);
                      const productTxns = resellerTxns.filter((t: any) => pick(t, 'affiliateProductId') === productId);
                      const soldCount = productTxns.length;
                      const affiliateEarning = productTxns.reduce((s: number, t: any) => s + Number(t.Amount || t.amount || 0), 0);
                      const merchantEarning = getProductMerchantEarning(productId);
                      return { p, productId, soldCount, affiliateEarning, merchantEarning };
                    })
                    .filter((row: any) => row.soldCount > 0);

                  if (soldRows.length === 0) {
                    return <tr><td colSpan={8} className="text-center text-muted py-4">No sold products yet.</td></tr>;
                  }

                  return soldRows.map((row: any, i: number) => {
                    const { p, productId, soldCount, affiliateEarning, merchantEarning } = row;
                    const saleAmount = merchantEarning + affiliateEarning;
                    return (
                      <tr key={productId ?? i}>
                        <td>{i + 1}</td>
                        <td><b>{pick(p, 'itemName')}</b></td>
                        <td>{pick(p, 'marginNumber')}%</td>
                        <td>{soldCount}</td>
                        <td>₹{saleAmount.toFixed(2)}</td>
                        <td>₹{merchantEarning.toFixed(2)}</td>
                        <td>₹{affiliateEarning.toFixed(2)}</td>
                        <td>
                          <span className="pointer table-action" onClick={(e) => { e.stopPropagation(); goTracking(productId); }}>
                            <i className="fas fa-route"></i> Track
                          </span>
                        </td>
                      </tr>
                    );
                  });
                })()}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  };
  const activeList = viewMode === 'reselling' ? merchants : myResellers;
  const [selectedId, setSelectedId] = useState<any>(null);
  const selected = activeList.find((m: any) => m.id === selectedId) || null;

 const switchMode = (mode: 'reselling' | 'myproducts') => {
  setViewMode(mode);
  setSelectedId(null);
  setProductSearch('');
  setShowAllDetails(false);
  setExpandedIds(new Set());
};
  const selectLabel = viewMode === 'reselling' ? 'Supplier' : 'Merchant';

  return (
    <div className="affiliate-dash-ui">
      <div style={{ height: '85px' }}></div>

      <div className="breadcrumb-bar px-4" style={{ backgroundColor: '#f5f1e8' }}>
  <Breadcrumbs aria-label="breadcrumb">
    <span className="pointer breadcrumb-link" onClick={navToDashboard}>Dashboard</span>
    <Typography style={{ color: '#3c4858', fontWeight: 500 }}>Affiliate Dashboard</Typography>
  </Breadcrumbs>
    <style>{`
    @keyframes affiliateBellPulse {
      0% { color: #ff6f00; }
      50% { color: #ff1744; }
      100% { color: #ff6f00; }
    }
    .notif-blink {
      animation: affiliateBellPulse 1s infinite;
      position: relative;
    }
    .notif-blink::after {
      content: '';
      position: absolute;
      top: -3px;
      right: -4px;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #ff1744;
      animation: notifDotPulse 1.5s infinite;
    }
    @keyframes notifDotPulse {
      0% { box-shadow: 0 0 0 0 rgba(255,23,68,0.6); }
      70% { box-shadow: 0 0 0 8px rgba(255,23,68,0); }
      100% { box-shadow: 0 0 0 0 rgba(255,23,68,0); }
    }
  `}</style>
  <div className="left-icons">
    <i
      className={`fas fa-bell pointer tracking-icon${hasUnreadNotifications ? ' notif-blink' : ''}`}
      title="Affiliate Notifications"
      onClick={handleBellIconClick}
    ></i>
    <i
      className={`fas fa-route pointer tracking-icon${hasUnreadNotifications ? ' notif-blink' : ''}`}
      title="Affiliate Tracking"
      onClick={handleTrackingIconClick}
    ></i>
    <i className="fas fa-sync-alt pointer refresh-icon" title="Refresh" onClick={fetchAll}></i>
  </div>
</div>

<div className="affiliate-section-tabs px-4" style={{ display: 'flex', gap: 8, paddingTop: 10, paddingBottom: 10 }}>
  <button
    className="pointer"
    style={{ border: '1px solid #ccc', borderRadius: 4, padding: '4px 14px', fontSize: 13, background: '#fff', cursor: 'pointer' }}
    onClick={() => navigate({ targetRoute: '/provider/affiliatemarketing', targetTitle: 'Affiliate Products', targetData: {}, sourceState: {}, eventSource: '' })}
  >
    Products
  </button>
  <button
    className="pointer"
    style={{ border: 'none', borderRadius: 4, padding: '4px 14px', fontSize: 13, background: '#ff6f00', color: '#fff', cursor: 'pointer' }}
  >
    Analytics
  </button>
</div>

                 <style>{`

        .affiliate-dash-ui .filter-pill-row {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 8px;
          width: 100%;
        }
        .affiliate-dash-ui .filter-pill-row > .affiliate-panel-bell {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          margin-left: auto;
          flex-shrink: 0;
          width: 36px;
          height: 36px;
          padding: 0;
          border: 1px solid #f69516;
          border-radius: 10px;
          background: #fff7eb;
          color: #b85e00;
          cursor: pointer;
        }
        .affiliate-dash-ui .filter-pill-row > .affiliate-panel-bell .aff-seg-bell {
          font-size: 17px;
          color: inherit;
          position: relative;
        }
        .affiliate-dash-ui .filter-pill-row > .affiliate-panel-bell:hover {
          background: #ffedcf;
        }
        .affiliate-dash-ui .filter-pill-row > .affiliate-panel-bell:focus-visible {
          outline: 3px solid #8ec73d;
          outline-offset: 2px;
        }
        .aff-seg-bell { font-size: 13px; color: #bbb; position: relative; padding: 2px; }
        .aff-seg-bell.has-unread { animation: affBellPulse 1s infinite; }
        .aff-seg-bell.has-unread::after {
          content: ''; position: absolute; top: -2px; right: -3px; width: 7px; height: 7px;
          border-radius: 50%; background: #ff1744; animation: affDotPulse 1.5s infinite;
        }
        @keyframes affBellPulse { 0%{color:#ff6f00} 50%{color:#ff1744} 100%{color:#ff6f00} }
        @keyframes affDotPulse {
          0%{box-shadow:0 0 0 0 rgba(255,23,68,.6)} 70%{box-shadow:0 0 0 7px rgba(255,23,68,0)} 100%{box-shadow:0 0 0 0 rgba(255,23,68,0)}
        }
        @media (max-width: 600px) {
          .stat-cards { flex-direction: column; }
          .stat-cards > * { width: 100%; }
        }
      `}</style>

      <div className="dash-layout px-4 py-3" style={{ display: 'block' }}>

      <div className="aff-dashboard-mode">
              <div className="aff-seg" role="tablist" aria-label="Affiliate dashboard view">
                <button
                  type="button"
                  role="tab"
                  aria-selected={viewMode === 'reselling'}
                  className={'aff-seg-btn' + (viewMode === 'reselling' ? ' active' : '')}
                  onClick={() => switchMode('reselling')}
                >
                  <i className="fas fa-truck"></i>
                  <span>Suppliers</span>
                </button>
                <button
                  type="button"
                  role="tab"
                  aria-selected={viewMode === 'myproducts'}
                  className={'aff-seg-btn' + (viewMode === 'myproducts' ? ' active' : '')}
                  onClick={() => switchMode('myproducts')}
                >
                  <i className="fas fa-users"></i>
                  <span>Merchants</span>
                </button>
              </div>

      </div>

        {/* ===== RIGHT PANEL ===== */}
        <div className="main-panel">
          {loading ? (
            <div className="py-5 text-center font-14 text-muted">Loading...</div>
          ) : (
            <>
              <div className="panel-header">
                <div>
                  <div className="font-22 panel-title">
                    <i className="fas fa-chart-bar text-orange pr-2"></i>Affiliate Dashboard
                  </div>
                  <div className="font-13 text-muted pt-1">
                    Track your affiliate performance and earnings at a glance.
                  </div>
                </div>
                <div className="header-right-controls">
                  <select
                    className="merchant-select"
                    value={selectedId ?? ''}
                   onChange={(e) => { setSelectedId(e.target.value ? Number(e.target.value) : null); setShowAllDetails(false); }}
                  >
                    <option value="">Select {selectLabel}</option>
                    {activeList.map((m: any) => (
                      <option key={m.id} value={m.id}>{m.name}</option>
                    ))}
                  </select>
                 <div className="filter-icon-btn" title={selectLabel}>
  <i className="fas fa-store"></i>
</div>
                </div>
                            </div>

              <div className="font-12 text-muted text-right pb-2">
                Last Updated: {lastUpdated.toLocaleString()}
              </div>
                            <div className="filter-pill-row">
                {quickFilters.map((f) => (
                  <button
                    key={f.key}
                    className={'filter-pill' + (dateFilter === f.key ? ' active' : '')}
                    onClick={() => { setDateFilter(f.key); setCustomFrom(''); setCustomTo(''); }}
                  >
                    <i className={`fas ${f.icon}`}></i>{f.label}
                  </button>
                ))}

                <div className="filter-pill-divider"></div>

                <div className="custom-range-inline">
                  <i className="fas fa-calendar-alt custom-range-icon"></i>
                  <input
                    type="date"
                    value={customFrom}
                    onChange={(e) => setCustomFrom(e.target.value)}
                    title="From"
                  />
                  <span className="custom-range-sep">→</span>
                  <input
                    type="date"
                    value={customTo}
                    onChange={(e) => setCustomTo(e.target.value)}
                    title="To"
                  />
                  <button
                    className={'filter-pill custom-range-apply-pill' + (dateFilter === 'custom' ? ' active' : '')}
                    disabled={!customFrom && !customTo}
                    onClick={() => setDateFilter('custom')}
                  >
                    Apply
                  </button>
                </div>
  <button
    type="button"
    className="affiliate-panel-bell"
    title={
      viewMode === 'reselling'
        ? 'Supplier notifications'
        : 'Merchant notifications'
    }
    aria-label={
      viewMode === 'reselling'
        ? 'Supplier notifications'
        : 'Merchant notifications'
    }
    onClick={(e) =>
      handleSideBellClick(
        e,
        viewMode === 'reselling' ? 'supplier' : 'merchant'
      )
    }
  >
    <i
      className={
        'fas fa-bell aff-seg-bell' +
        (
          (viewMode === 'reselling'
            ? unreadSupplierCount
            : unreadMerchantCount) > 0
            ? ' has-unread'
            : ''
        )
      }
      aria-hidden="true"
    />
  </button>
              </div>

              {viewMode === 'reselling' ? (
                <>
                  {showAllDetails ? (
                    <div className="fade-slide-in">
                      <div className="back-to-list pointer" onClick={() => setShowAllDetails(false)}>
                        <i className="fas fa-arrow-left"></i> Back to Summary
                      </div>
                                          <div className="font-18 pb-3"><b>Merchants I'm Affiliating From ({merchants.length})</b></div>
                      <div className="font-12 text-muted pb-3">Products you promote from each supplier, what's sold through your link, and commission you earned.</div>
                      {merchants.length === 0 && <div className="text-center text-muted py-4">No suppliers found.</div>}
                      {merchants.map((m: any) => renderSupplierBlock(m))}
                    </div>
                  ) : !selected ? (
                    <>
                      

                      <div className="stat-cards">
                        <div className="stat-card blue-bg" onClick={() => setShowAllDetails(true)}>
                          <div className="stat-card-icon blue"><i className="fas fa-shopping-cart"></i></div>
                          <div className="font-15"><b>Products I Promote</b></div>
                          <div className="font-30"><b>{acceptedProducts.length}</b></div>
                          <div className="font-12 text-muted">Total supplier products currently added/promoted by you.</div>
                        </div>
                        <div className="stat-card green-bg" onClick={() => setShowAllDetails(true)}>
                          <div className="stat-card-icon green"><i className="fas fa-shopping-basket"></i></div>
                          <div className="font-15"><b>Products Sold By Me</b></div>
                          <div className="font-30"><b>{salesCount}</b></div>
                          <div className="font-12 text-muted">Total supplier products sold through your affiliate promotion.</div>
                        </div>
                        <div className="stat-card purple-bg" onClick={() => setShowAllDetails(true)}>
                          <div className="stat-card-icon purple"><i className="fas fa-rupee-sign"></i></div>
                          <div className="font-15"><b>My Commission Earned</b></div>
                          <div className="font-30"><b>₹{commission.toFixed(2)}</b></div>
                          <div className="font-12 text-muted">Total affiliate commission earned from promoting supplier products.</div>
                        </div>
                      </div>

                      <div className="info-banner">
                        <div className="info-banner-icon"><i className="fas fa-info"></i></div>
                        <div>
                          <div className="font-14"><b>Supplier-specific details will be shown here once you select a supplier</b></div>
                          <div className="font-12 text-muted pt-1">Click on 'Select Supplier' above to view the list of suppliers and their details.</div>
                        </div>
                      </div>
                    </>
                  ) : (() => {
                    const merchantProducts = acceptedProducts.filter((p: any) => pick(p, 'merchantId') === selected.id);
                    const merchantSales = filteredSales.filter((s: any) =>
  merchantProducts.some((p: any) => getProductKey(p) === getSaleProductKey(s))
);
                    const commissionEarned = merchantSales.reduce((sum: number, s: any) => sum + Number(s.Amount || s.amount || 0), 0);
                    const visibleProducts = merchantProducts.filter((p: any) => {
                      if (!productSearch) return true;
                      return (pick(p, 'itemName') || '').toLowerCase().includes(productSearch.toLowerCase());
                    });

                                                                            const soldItemRows = merchantSales.map((s: any) => {
                      const key = getSaleProductKey(s);
                      const matchedProduct = merchantProducts.find((p: any) => getProductKey(p) === key);
                      const amount = Number(s.Amount || s.amount || 0);
                      const merchantAmount = Number(pick(s, 'counterpartAmount') || 0);
                      return {
                        itemName: pick(matchedProduct, 'itemName') || pick(s, 'ItemName', 'ProductName') || 'Unknown item',
                        amount,
                        merchantAmount,
                        saleTotal: amount + merchantAmount,
                        date: s.CreatedDate || s.createdDate,
                        buyer: pick(s, 'BuyerName', 'CustomerName') || 'N/A',
                      };
                    });

                    return (
                      <div className="merchant-detail-page fade-slide-in">
                        <div className="back-to-list pointer" onClick={() => setSelectedId(null)}>
                          <i className="fas fa-arrow-left"></i> Back to Merchants
                        </div>

                        <div className="merchant-info-card">
                          <div className="merchant-avatar">{selected.name.charAt(0).toUpperCase()}</div>
                          <div className="merchant-info-main">
                            <div className="merchant-info-name">
                              {selected.name} <span className="status-pill active">Active</span>
                            </div>
                          </div>
                          <div className="merchant-info-stats">
                            <div className="mini-stat">
                              <div className="mini-stat-label">Products Promoted</div>
                              <div className="mini-stat-value">{merchantProducts.length}</div>
                            </div>
                            <div className="mini-stat">
                              <div className="mini-stat-label">Products Sold</div>
                              <div className="mini-stat-value">{merchantSales.length}</div>
                            </div>
                            <div className="mini-stat">
                              <div className="mini-stat-label">Commission Earned</div>
                              <div className="mini-stat-value">₹{commissionEarned.toFixed(2)}</div>
                            </div>
                          </div>
                        </div>

                                                {soldItemRows.length > 0 && (
                          <div className="sold-items-section fade-slide-in">
                            <div className="font-16 pb-2"><b>Sold Items ({soldItemRows.length})</b></div>
                            <div className="merchant-table-wrap" style={{ marginBottom: 20 }}>
                                                            <table className="merchant-table">
                                <thead>
                                  <tr>
                                    <th>#</th>
                                    <th>Product Name</th>
                                    <th>Buyer</th>
                                    <th>Sale Amount</th>
                                    <th>Merchant Earning</th>
                                    <th>Commission Earned</th>
                                    <th>Date</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {soldItemRows.map((row: any, i: number) => (
                                    <tr key={i}>
                                      <td>{i + 1}</td>
                                      <td><b>{row.itemName}</b></td>
                                      <td>{row.buyer}</td>
                                      <td>₹{row.saleTotal.toFixed(2)}</td>
                                      <td>₹{row.merchantAmount.toFixed(2)}</td>
                                      <td>₹{row.amount.toFixed(2)}</td>
                                      <td>{row.date ? new Date(row.date).toLocaleDateString('en-IN') : 'N/A'}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        )}

                        <div className="products-table-header">
                          <div className="font-16"><b>Products from {selected.name}</b></div>
                          <input
                            type="text"
                            className="product-search-input"
                            placeholder="Search product..."
                            value={productSearch}
                            onChange={(e) => setProductSearch(e.target.value)}
                          />
                        </div>

                        <div className="merchant-table-wrap">
                                                    <table className="merchant-table">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Product Name</th>
                                <th>Commission Rate</th>
                                <th>Sold</th>
                                <th>Sale Amount</th>
                                <th>Merchant Earning</th>
                                <th>Your Commission</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                                                            {visibleProducts.map((p: any, i: number) => {
                             const productId = getProductKey(p);
const earned = getProductEarned(productId);
const merchantAmount = getProductCounterpartAmount(productId);
const saleAmount = earned + merchantAmount;
const soldCount = filteredSales.filter((s: any) => getSaleProductKey(s) === productId).length;
                                return (
                                  <tr key={productId ?? i}>
                                    <td>{i + 1}</td>
                                    <td><b>{pick(p, 'itemName')}</b></td>
                                    <td>{pick(p, 'marginNumber')}%</td>
                                    <td>{soldCount}</td>
                                    <td>₹{saleAmount.toFixed(2)}</td>
                                    <td>₹{merchantAmount.toFixed(2)}</td>
                                    <td>₹{earned.toFixed(2)}</td>
                                    <td>
                                      <span className="pointer table-action" onClick={() => goTracking(productId)}>
                                        <i className="fas fa-route"></i> Track
                                      </span>
                                    </td>
                                  </tr>
                                );
                              })}
                              {visibleProducts.length === 0 && (
                                <tr><td colSpan={8} className="text-center text-muted py-4">No products found.</td></tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    );
                                    })()}
                </>
              ) : (
                <>
                  {showAllDetails ? (
                    <div className="fade-slide-in">
                      <div className="back-to-list pointer" onClick={() => setShowAllDetails(false)}>
                        <i className="fas fa-arrow-left"></i> Back to Summary
                      </div>
                                          <div className="font-18 pb-3"><b>Suppliers Reselling My Products ({myResellers.length})</b></div>
                      <div className="font-12 text-muted pb-3">Products each supplier promotes from you, what's sold through them, and commission you paid them.</div>
                      {myResellers.length === 0 && <div className="text-center text-muted py-4">No suppliers found.</div>}
                      {myResellers.map((r: any) => renderMerchantBlock(r))}
                    </div>
                  ) : !selected ? (
                    <>
                     
                      <div className="stat-cards">
                        <div className="stat-card blue-bg" onClick={() => setShowAllDetails(true)}>
                          <div className="stat-card-icon blue"><i className="fas fa-box"></i></div>
                          <div className="font-15"><b>Products Sold by Merchants</b></div>
                          <div className="font-30"><b>{filteredResellerEarnings.length}</b></div>
                          <div className="font-12 text-muted">Total number of your products sold through affiliates.</div>
                        </div>
                        <div className="stat-card orange-bg" onClick={() => setShowAllDetails(true)}>
                          <div className="stat-card-icon orange"><i className="fas fa-rupee-sign"></i></div>
                          <div className="font-15"><b>Affiliate Commission Paid</b></div>
                          <div className="font-30"><b>₹{filteredResellerEarnings.reduce((s: number, t: any) => s + Number(t.Amount || t.amount || 0), 0).toFixed(2)}</b></div>
                          <div className="font-12 text-muted">Total affiliate commission you have paid/owe to affiliates for selling your products.</div>
                        </div>
                        <div className="stat-card green-bg" onClick={() => setShowAllDetails(true)}>
                          <div className="stat-card-icon green"><i className="fas fa-chart-line"></i></div>
                          <div className="font-15"><b>My Affiliate Sales Revenue</b></div>
                          <div className="font-30"><b>₹{commission.toFixed(2)}</b></div>
                          <div className="font-12 text-muted">Total sales value generated through affiliates for your products.</div>
                        </div>
                      </div>

                      <div className="info-banner">
                        <div className="info-banner-icon"><i className="fas fa-info"></i></div>
                        <div>
                          <div className="font-14"><b>Merchant-specific details will be shown here once you select a merchant</b></div>
                          <div className="font-12 text-muted pt-1">Click on 'Select Merchant' above to view the list of merchants and their details.</div>
                        </div>
                      </div>
                    </>
                  ) : (() => {
                    const resellerProducts = merchantSideProducts.filter((p: any) =>
                      pick(p, 'resellerId') === selected.id && (pick(p, 'requestStatus') ?? '').toLowerCase() === 'accepted'
                    );

                    // Use the reseller's own wallet transactions, not the logged-in merchant's own sales
                                        const resellerTxns = filteredResellerEarnings.filter((t: any) => pick(t, 'userId') === selected.id);
                    const commissionPaid = resellerTxns.reduce((sum: number, t: any) => sum + Number(t.Amount || t.amount || 0), 0);
                    const meta = resellerProducts[0] || {};

                    const soldItemRows = resellerTxns.map((t: any) => {
                      const orderId = pick(t, 'orderId');
                      const affiliateAmt = Number(t.Amount || t.amount || 0);
                      const merchantAmt = getOrderMerchantAmount(orderId);
                      return {
                        itemName: pick(t, 'itemName') || 'Unknown item',
                        amount: affiliateAmt,
                        merchantAmount: merchantAmt,
                        saleTotal: affiliateAmt + merchantAmt,
                        date: t.CreatedDate || t.createdDate,
                      };
                    });

                    return (
                      <div className="merchant-detail-page fade-slide-in">
                        <div className="back-to-list pointer" onClick={() => setSelectedId(null)}>
                          <i className="fas fa-arrow-left"></i> Back to Merchants
                        </div>

                        <div className="merchant-info-card">
                          <div className="merchant-avatar">{selected.name.charAt(0).toUpperCase()}</div>
                          <div className="merchant-info-main">
                            <div className="merchant-info-name">
                              {selected.name} <span className="status-pill active">Active</span>
                            </div>
                            {(pick(meta, 'resellerStallName') || pick(meta, 'resellerAddress')) && (
                              <div className="font-12 text-muted pt-1">
                                {pick(meta, 'resellerStallName')}
                                {pick(meta, 'resellerStallName') && pick(meta, 'resellerAddress') ? ' — ' : ''}
                                {pick(meta, 'resellerAddress')}
                              </div>
                            )}
                          </div>
                          <div className="merchant-info-stats">
                            <div className="mini-stat">
                              <div className="mini-stat-label">Products Promoted</div>
                              <div className="mini-stat-value">{resellerProducts.length}</div>
                            </div>
                            <div className="mini-stat">
                              <div className="mini-stat-label">Products Sold</div>
                              <div className="mini-stat-value">{resellerTxns.length}</div>
                            </div>
                            <div className="mini-stat">
                              <div className="mini-stat-label">Affiliate Commission Paid</div>
                              <div className="mini-stat-value">₹{commissionPaid.toFixed(2)}</div>
                            </div>
                          </div>
                        </div>

                        {soldItemRows.length > 0 && (
                          <div className="sold-items-section fade-slide-in">
                            <div className="font-16 pb-2"><b>Sold Items ({soldItemRows.length})</b></div>
                            <div className="merchant-table-wrap" style={{ marginBottom: 20 }}>
                                                            <table className="merchant-table">
                                <thead>
                                  <tr>
                                    <th>#</th>
                                    <th>Product Name</th>
                                    <th>Sale Amount</th>
                                    <th>Merchant Earning</th>
                                    <th>Affiliate Earning</th>
                                    <th>Date</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {soldItemRows.map((row: any, i: number) => (
                                    <tr key={i}>
                                      <td>{i + 1}</td>
                                      <td><b>{row.itemName}</b></td>
                                      <td>₹{row.saleTotal.toFixed(2)}</td>
                                      <td>₹{row.merchantAmount.toFixed(2)}</td>
                                      <td>₹{row.amount.toFixed(2)}</td>
                                      <td>{row.date ? new Date(row.date).toLocaleDateString('en-IN') : 'N/A'}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        )}

                        <div className="products-table-header">
                          <div className="font-16"><b>Products {selected.name} is Reselling</b></div>
                        </div>

                        <div className="merchant-table-wrap">
                          <table className="merchant-table">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Product Name</th>
                                <th>Commission Rate</th>
                                <th>Sold</th>
                              </tr>
                            </thead>
                            <tbody>
                              {resellerProducts.map((p: any, i: number) => {
                                const productId = getProductKey(p);
                                const soldCount = resellerTxns.filter((t: any) => pick(t, 'affiliateProductId') === productId).length;
                                return (
                                  <tr key={productId ?? i}>
                                    <td>{i + 1}</td>
                                    <td><b>{pick(p, 'itemName')}</b></td>
                                    <td>{pick(p, 'marginNumber')}%</td>
                                    <td>{soldCount}</td>
                                  </tr>
                                );
                              })}
                              {resellerProducts.length === 0 && (
                                <tr><td colSpan={4} className="text-center text-muted py-4">No products found.</td></tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    );
                  })()}
                </>
              )}
            </>
          )}
        </div>
      </div>

      <Popover
        open={Boolean(trackingAnchorEl)}
        anchorEl={trackingAnchorEl}
        onClose={() => setTrackingAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
                        <div style={{ minWidth: 280, maxHeight: 400, overflowY: 'auto', padding: 8 }}>
          <div className="font-16 p-2" style={{ borderBottom: '1px solid #eee' }}>
            <b>Affiliate Tracking</b>
          </div>
          {myTrackable.length === 0 && (
            <div className="p-3 font-13 text-muted text-center">No tracking items yet.</div>
          )}
          {myTrackable.map((req: any, idx: number) => {
            const id = pick(req, 'Id', 'AffiliateProductId');
            const itemName = pick(req, 'ItemName', 'ProductName');
            const status = pick(req, 'RequestStatus', 'Status');
            const isMerchantView = pick(req, 'IsMerchantView');
            const counterpartName = isMerchantView
              ? (pick(req, 'ResellerName') || 'Unknown reseller')
              : (pick(req, 'MerchantStallName') || 'Unknown merchant');
            const statusClass = (status ?? '').toLowerCase();

            return (
              <div
                key={id ?? idx}
                className="tracking-popover-row pointer"
                onClick={() => id && goTracking(id)}
              >
                <div className="tracking-popover-icon">
                  <i className="fas fa-route"></i>
                </div>
                <div className="tracking-popover-info">
                  <div className="font-14"><b>{itemName ?? 'Unnamed item'}</b></div>
                  <div className="font-12 text-muted">
                    {isMerchantView ? 'Merchant: ' : 'Supplier: '}{counterpartName}
                  </div>
                  <span className={`tracking-status-chip ${statusClass}`}>{status ?? ''}</span>
                </div>
                <i className="fas fa-chevron-right tracking-popover-arrow"></i>
                            </div>
            );
          })}
        </div>
      </Popover>

            <Popover
        open={Boolean(bellAnchorEl)}
        anchorEl={bellAnchorEl}
        onClose={() => setBellAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <div style={{ minWidth: 320, maxHeight: 440, overflowY: 'auto', padding: 8 }}>
          <div className="font-16 p-2" style={{ borderBottom: '1px solid #eee' }}>
            <b>Affiliate Notifications</b>
          </div>

          {affiliateNotifications.length === 0 && (
            <div className="p-3 font-13 text-muted text-center">No affiliate notifications yet.</div>
          )}

          {affiliateNotifications.filter((n: any) => n.notificationCategory === 'AffiliateRequest').length > 0 && (
            <div className="font-12 text-muted" style={{ padding: '10px 10px 4px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.3 }}>
              As Merchant — Requests For Your Products
            </div>
          )}
          {affiliateNotifications
            .filter((n: any) => n.notificationCategory === 'AffiliateRequest')
            .map((notif: any) => (
              <div
                key={notif.id}
                className="tracking-popover-row pointer"
                onClick={() => goToNotificationTarget(notif)}
              >
                <div className="tracking-popover-icon">
                  <i className="fas fa-bell"></i>
                </div>
                <div className="tracking-popover-info">
                  <div className="font-14">{notif.message}</div>
                  <span className="affiliate-side-tag merchant-tag">Merchant</span>
                  {!notif.isRead && (
                    <span style={{ color: 'red', marginLeft: 6 }}>●</span>
                  )}
                </div>
                <i className="fas fa-chevron-right tracking-popover-arrow"></i>
              </div>
            ))}

          {affiliateNotifications.filter((n: any) => n.notificationCategory !== 'AffiliateRequest').length > 0 && (
            <div className="font-12 text-muted" style={{ padding: '14px 10px 4px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.3, borderTop: '1px solid #f0f0f0', marginTop: 8 }}>
              As Supplier — Updates On Your Requests
            </div>
          )}
          {affiliateNotifications
            .filter((n: any) => n.notificationCategory !== 'AffiliateRequest')
            .map((notif: any) => (
              <div
                key={notif.id}
                className="tracking-popover-row pointer"
                onClick={() => goToNotificationTarget(notif)}
              >
                <div className="tracking-popover-icon">
                  <i className="fas fa-bell"></i>
                </div>
                <div className="tracking-popover-info">
                  <div className="font-14">{notif.message}</div>
                  <span className="affiliate-side-tag supplier-tag">Supplier</span>
                  {!notif.isRead && (
                    <span style={{ color: 'red', marginLeft: 6 }}>●</span>
                  )}
                </div>
                                <i className="fas fa-chevron-right tracking-popover-arrow"></i>
              </div>
            ))}
        </div>
      </Popover>

      <Popover
        open={Boolean(sideBellAnchorEl)}
        anchorEl={sideBellAnchorEl}
        onClose={() => { setSideBellAnchorEl(null); setSideBellSide(null); }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <div style={{ minWidth: 300, maxHeight: 400, overflowY: 'auto', padding: 8 }}>
          <div className="font-16 p-2" style={{ borderBottom: '1px solid #eee' }}>
            <b>{sideBellSide === 'merchant' ? 'Merchant Notifications' : 'Supplier Notifications'}</b>
          </div>
          {affiliateNotifications
            .filter((n: any) =>
              sideBellSide === 'merchant'
                ? n.notificationCategory === 'AffiliateRequest'
                : n.notificationCategory !== 'AffiliateRequest'
            ).length === 0 && (
            <div className="p-3 font-13 text-muted text-center">No notifications here yet.</div>
          )}
          {affiliateNotifications
            .filter((n: any) =>
              sideBellSide === 'merchant'
                ? n.notificationCategory === 'AffiliateRequest'
                : n.notificationCategory !== 'AffiliateRequest'
            )
            .map((notif: any) => (
              <div
                key={notif.id}
                className="tracking-popover-row pointer"
                onClick={() => goToNotificationTarget(notif)}
              >
                <div className="tracking-popover-icon">
                  <i className="fas fa-bell"></i>
                </div>
                <div className="tracking-popover-info">
                  <div className="font-14">{notif.message}</div>
                  <span className={`affiliate-side-tag ${sideBellSide === 'merchant' ? 'merchant-tag' : 'supplier-tag'}`}>
                    {sideBellSide === 'merchant' ? 'Merchant' : 'Supplier'}
                  </span>
                  {!notif.isRead && (
                    <span style={{ color: 'red', marginLeft: 6 }}>●</span>
                  )}
                </div>
                <i className="fas fa-chevron-right tracking-popover-arrow"></i>
              </div>
            ))}
        </div>
      </Popover>
    </div>
  );
};

export default AffiliateDashboard;